var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings-payout"},[_c('div',{staticClass:"stripe-form"},[_c('settings-payouts-modal',{attrs:{"financeAccount":!_vm.financeAccount}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }